import { compose, setDisplayName, withHandlers } from 'recompose';
import { mediaManagerLoaded } from '@wix/bi-logger-media-manager-g6/v2';
import { getDurationBetweenMarks, mark } from '../../../env/performance';
import { withMMGRSettings, withoutMMGRSettings } from '../../withMMGRSettings';
import { bi } from '../../../../services/loggers/bi';
import { IWithAppLoadedAnalyticsInner, IWithAppLoadedAnalyticsOuter } from './withAppLoadedAnalytics.types';
import { once } from 'ramda';
import { PerfMark } from '../../../../constants/PerfMark';
import { withFirst, withoutFirst } from '../../withFirst';
import { fedopsLogger } from '../../../../services/loggers/fedopsLogger';
import { withTrackMediaManagerLoadedObservers } from './withTrackMediaManagerLoadedObservers';

export const trackMediaManagerLoaded = (origin, openSource, isFirst) => {
  mark(PerfMark.LoadEnd);

  bi.logger().report(
    mediaManagerLoaded({
      // ignoring because next version of logger is broken and we need `isFirst`
      // @ts-expect-error
      isFirst,
      origin,
      source: openSource,
      loadingTime: Math.round(getDurationBetweenMarks(PerfMark.LoadStart, PerfMark.LoadEnd)),
    }),
  );
};

const trackFedopsAppLoaded = once(() => fedopsLogger.appLoaded());

export const withAppLoadedAnalytics = compose<IWithAppLoadedAnalyticsInner, IWithAppLoadedAnalyticsOuter>(
  setDisplayName('withAppLoadedAnalytics'),
  withMMGRSettings,
  withFirst('withAppLoadedAnalytics'),
  withTrackMediaManagerLoadedObservers,
  withHandlers({
    trackMediaManagerLoaded:
      ({ trackLoaded$, mmgrSettings: { origin, openSource }, isFirst, setFirst }) =>
      () => {
        trackFedopsAppLoaded();

        trackLoaded$.next(() => {
          trackMediaManagerLoaded(origin, openSource, isFirst);

          setFirst(false);
        });
      },
  }),
  withoutFirst,
  withoutMMGRSettings,
);
